// extracted by mini-css-extract-plugin
module.exports = {"age":"AgeingOnlyDescription_age__34rH4","score":"AgeingOnlyDescription_score__1QcwY"};